import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { InvitationPayload, User, UserInvitation } from 'src/app/shared/types/users.types';
import { ListResponseWrapper } from 'src/app/shared/http.types';
import { UsersProviderService, IUserProvider, IUserInvitationProvider } from './users-provider.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UsersService implements IUserProvider, IUserInvitationProvider {
  public onCreateInvitation: Subject<InvitationPayload> = new Subject<InvitationPayload>();

  constructor(
    private usersProviderService: UsersProviderService,
    private httpClient: HttpClient,
  ) { }

  public getUsers(accountId: string): Observable<ListResponseWrapper<User>> {
    return this.usersProviderService.getUsers(accountId);
  }

  public changeUserState(userId: User['id'], accountId: string, state: 'activate'|'deactivate'): Observable<any> {
    return this.usersProviderService.changeUserState(userId, accountId, state);
  }

  public getInvitations(accountId: string): Observable<ListResponseWrapper<UserInvitation>> {
    return this.usersProviderService.getInvitations(accountId);
  }

  public deleteInvitation(invitationId: UserInvitation['id'], accountId: string): Observable<any> {
    return this.usersProviderService.deleteInvitation(invitationId, accountId);
  }

  public cancelInvitation(invitaitonId: UserInvitation['id'], accountId: string): Observable<any> {
    return this.usersProviderService.cancelInvitation(invitaitonId, accountId);
  }

  public resendInvitation(invitaitonId: UserInvitation['id'], accountId: string): Observable<any> {
    return this.usersProviderService.resendInvitation(invitaitonId, accountId);
  }

  public createInvitation(accountId: string, body: InvitationPayload): Observable<any> {
    return this.usersProviderService.createInvitation(accountId, body);
  }

  public changeRole(accountId: string, userId: string, role: User.GroupName): Observable<void> {
    return this.usersProviderService.changeRole(accountId, userId, role);
  }

  public changePassword(newPassword: string) {
    return this.httpClient
      .put(`${environment.backendBaseUrl}/auth/users/change-password`, newPassword);
  }
}
